export default __webpack_public_path__ + "7c83779d1a17152b85b19fa3f424fcef.svg";